import React, { useState, useCallback, useEffect, useMemo } from "react";
import { toast } from "react-toastify";
import PriceBox from "./PriceBox";
import CollapseBox from "./CollapseBox";
import WXPayService from "../../services/wxPay.service";
import { currencyFormatter, getDateAsMonthYear, dateWithMonthsDelay as dateWithMonthsOffset, getMonthStartDate } from "../../utils/methods";
import { ErrorMessages as Errors } from "../../utils/apiConstants";
import ErrorInfoIcon from "../../assets/images/error-info-icon.svg";
import { useSummaryPriceRow } from "../../utils/customHooks";
import PriceTable from "./PriceTable";
import LeftArrow from "../../assets/images/left-arrow.svg";

const WXPaySummary: React.FC = () => {
  const [monthOffset, setMonthOffset] = useState<number>(0);
  const dates = useMemo(() => {
    return {
      thisMonth: dateWithMonthsOffset(getMonthStartDate(), monthOffset),
    };
  }, [monthOffset]);
  const [avgMrc, setAvgMrc] = useState<number>(0);
  const [currentBillingEstimation, setCurrentBillingEstimation] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const { handleSetIncomeExpenseRows, incomeRows, expenseRows, sums } = useSummaryPriceRow();
  const isComponentMounted = React.useRef(true);
  React.useEffect(() => {
    isComponentMounted.current = true;
    return () => {
      isComponentMounted.current = false;
    };
  }, []);
  const [collapsibleStates, setCollapsibleStates] = useState<{
    income: boolean;
    expense: boolean;
  }>({ income: true, expense: true });
  const getIncomeExpense = useCallback(() => {
    setLoading(true);
    const startDate = Date.parse(new Date(dates.thisMonth).toUTCString());
    const payload = {
      startDate,
      nowTime: Date.parse(new Date().toUTCString()),
    };
    WXPayService.getWXPaySummary(payload)
      .then((response: any) => {
        if (!isComponentMounted.current) return;
        setLoading(false);
        setAvgMrc(response?.data?.avgMrc);
        setCurrentBillingEstimation(response?.data?.currentBillingEstimation);
        handleSetIncomeExpenseRows(response?.data?.priceRows, response?.data?.sums);
      })
      .catch((e: any) => {
        if (!isComponentMounted.current) return;
        toast.error(Errors.internalServerError, { icon: <img src={ErrorInfoIcon} alt="Error" className="error-icon" /> });
        setLoading(false);
      });
  }, [dates.thisMonth, handleSetIncomeExpenseRows]);
  useEffect(() => {
    getIncomeExpense();
  }, [monthOffset]);

  const handleCollapsibleNEClose = useCallback(
    (id: string) => {
      setCollapsibleStates((prev: any) => {
        return {
          ...prev,
          [id]: false,
        };
      });
    },
    [setCollapsibleStates]
  );

  const handleCollapsibleNEOpen = useCallback(
    (id: string) => {
      setCollapsibleStates((prev: any) => {
        return {
          ...prev,
          [id]: true,
        };
      });
    },
    [setCollapsibleStates]
  );

  const incomeTable =
    sums.mrcIncome + sums.totalIncome > 0 ? (
      <>
        <h2 style={{ paddingBottom: "5px" }}>Income</h2>
        <PriceTable notApplicable={monthOffset < 0} priceRow={incomeRows} type="income" loading={loading} />
      </>
    ) : (
      //   <CollapseBox
      //     text="Income"
      //     id="income"
      //     sums={{ mrc: sums.mrcIncome, total: sums.totalIncome }}
      //     open={collapsibleStates.income}
      //     onCollapsibleNEClose={handleCollapsibleNEClose}
      //     onCollapsibleNEOpen={handleCollapsibleNEOpen}
      //     table={<PriceTable notApplicable={monthOffset < 0} priceRow={incomeRows} type="income" loading={loading} />}
      //   />
      // )
      <div />
    );
  const expenseTable =
    sums.mrcExpense + sums.totalExpense > 0 ? (
      <>
        <h2 style={{ paddingBottom: "5px" }}>Expense</h2>
        <PriceTable notApplicable={monthOffset < 0} priceRow={expenseRows} type="expense" loading={loading} />
      </>
    ) : (
      //   <CollapseBox
      //     text="Expense"
      //     id="expense"
      //     sums={{ mrc: sums.mrcExpense, total: sums.totalExpense }}
      //     open={collapsibleStates.expense}
      //     onCollapsibleNEClose={handleCollapsibleNEClose}
      //     onCollapsibleNEOpen={handleCollapsibleNEOpen}
      //     table={<PriceTable notApplicable={monthOffset < 0} priceRow={expenseRows} type="expense" loading={loading} />}
      //   />
      // )
      <div />
    );
  // const currentBillingPeriodPriceBoxTitle = `${getDateAsMonthYear(dates.thisMonth)} Billing Period ${monthOffset >= 0 ? "Estimate" : ""}`;
  const moreExpense = sums.mrcExpense + sums.totalExpense < sums.mrcIncome + sums.totalIncome;
  const currentBillingPeriodPriceBoxTitle = `Billing Period ${monthOffset >= 0 ? "Estimate" : ""}`;
  const monthYear = getDateAsMonthYear(dates.thisMonth);
  return (
    <div className="wx-pay-component-root">
      {/* <div className="price-boxes">
        <div className="month-box" style={{ visibility: 'hidden' }} />
        <PriceBox
          estimate={monthOffset >= 0}
          loading={loading}
          text={currentBillingPeriodPriceBoxTitle}
          amount={currentBillingEstimation < 0 ? `(${currencyFormatter(Math.abs(currentBillingEstimation))})` : currencyFormatter(Number(currentBillingEstimation))}
          color="blue"
          changeMonthHook={setMonthOffset}
        />
        <PriceBox
          estimate
          notApplicable={monthOffset < 0}
          loading={loading}
          text="Monthly Recurring Estimate"
          amount={avgMrc < 0 ? `(${currencyFormatter(Math.abs(avgMrc))})` : currencyFormatter(Number(avgMrc))}
          color="green"
        />
      </div> */}
      <div className="price-boxes">
        <div className="box flex">
          <div style={{ textAlign: "center" }}>
            <div className="header">Billing Period</div>
            <div className="title">
              <div className="arrows left" onClick={() => setMonthOffset((prev: number) => prev - 1)}>
                {"<"}
              </div>
              {monthYear}
              <div className="arrows right" onClick={() => setMonthOffset((prev: number) => prev + 1)}>
                {">"}
              </div>
            </div>
          </div>
        </div>
        <div className="box flex right">
          <div style={{ textAlign: "right" }}>
            <div className="header">{currentBillingPeriodPriceBoxTitle}</div>
            <div className="title">
              {currentBillingEstimation < 0
                ? `( $${currencyFormatter(Math.abs(currentBillingEstimation))} )`
                : `$${currencyFormatter(Number(currentBillingEstimation))}`}
            </div>
          </div>
        </div>
        <div className="box flex right">
          <div style={{ textAlign: "right" }}>
            <div className="header">Monthly Recurring Estimate</div>
            <div className="title">{avgMrc < 0 ? `( $${currencyFormatter(Math.abs(avgMrc))} )` : `$${currencyFormatter(Number(avgMrc))}`}</div>
          </div>
        </div>
      </div>
      {moreExpense ? (
        <div className="accordians">
          {incomeTable}
          {expenseTable}
        </div>
      ) : (
        <div className="accordians">
          {expenseTable}
          {incomeTable}
        </div>
      )}
    </div>
  );
};

export default WXPaySummary;
